import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const APPT_MGMT_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap');

  .am-root {
    padding: 24px;
    font-family: 'Outfit', sans-serif;
    color: #1e293b;
  }

  .am-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(20px);
    padding: 32px 40px;
    border-radius: 32px;
    border: 1px solid #fff;
    box-shadow: 0 20px 50px rgba(186, 230, 253, 0.3);
    margin-bottom: 40px;
  }

  .am-title { font-size: 32px; font-weight: 800; color: #0c4a6e; margin: 0; }
  .am-subtitle { font-size: 14px; font-weight: 600; color: #64748b; text-transform: uppercase; letter-spacing: 1.5px; }

  /* ── Grid ── */
  .dl-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 24px;
    position: relative;
    z-index: 1;
  }

  /* ── Card ── */
  .dl-card-outer {
    position: relative;
    border-radius: 24px;
    padding: 2px;
    background: white;
    transition: all 0.4s cubic-bezier(.22,.68,0,1.2);
    box-shadow: 0 10px 30px rgba(186, 230, 253, 0.2);
  }
  .dl-card-outer:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 40px rgba(186, 230, 253, 0.4);
  }

  .dl-card-ring {
    position: absolute;
    inset: 0;
    border-radius: 24px;
    padding: 2px;
    background: conic-gradient(
      from var(--angle, 0deg),
      transparent 0deg,
      #0284c7 60deg,
      #7c3aed 120deg,
      #0ea5e9 180deg,
      transparent 240deg
    );
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    opacity: 0;
    transition: opacity 0.4s ease;
    pointer-events: none;
  }
  .dl-card-outer:hover .dl-card-ring {
    opacity: 1;
    animation: spin-light 2s linear infinite;
  }

  .dl-card-inner {
    background: #ffffff;
    border-radius: 22px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    height: 100%;
    border: 1px solid #f0f9ff;
    position: relative;
  }

  .am-ref-badge {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 11px;
    font-weight: 800;
    color: #0369a1;
    background: #e0f2fe;
    padding: 6px 12px;
    border-radius: 8px;
    border: 1px solid #bae6fd;
  }

  .am-part-badge {
    font-size: 11px;
    font-weight: 700;
    padding: 6px 12px;
    border-radius: 8px;
    display: inline-block;
  }
  .am-doc-badge { color: #059669; background: #ecfdf5; border: 1px solid #d1fae5; }
  .am-user-badge { color: #7c3aed; background: #f5f3ff; border: 1px solid #ede9fe; }

  .am-date { font-size: 20px; font-weight: 800; color: #0c4a6e; margin-bottom: 4px; }
  .am-time { font-size: 14px; font-weight: 700; color: #0284c7; display: flex; align-items: center; gap: 6px; }

  .dl-divider { height: 1px; background: #f1f5f9; margin: 16px 0; }

  .am-btn-action {
    flex: 1;
    padding: 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 800;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid #e2e8f0;
    background: #fff;
    color: #475569;
    text-align: center;
    box-shadow: 0 4px 12px rgba(0,0,0,0.02);
  }
  .am-btn-action:hover { background: #f8fafc; transform: translateY(-2px); box-shadow: 0 6px 15px rgba(0,0,0,0.05); }

  .am-btn-primary {
    background: linear-gradient(135deg, #0284c7, #0ea5e9);
    color: #fff;
    border: none;
    box-shadow: 0 6px 15px rgba(2, 132, 199, 0.2);
  }
  .am-btn-primary:hover { 
    background: linear-gradient(135deg, #0ea5e9, #0284c7);
    color: white;
    transform: translateY(-2px); 
    box-shadow: 0 10px 20px rgba(2, 132, 199, 0.3); 
  }

  /* Modal */
  .modal-overlay {
    position: fixed; inset: 0; background: rgba(15, 23, 42, 0.4); backdrop-filter: blur(8px); display: flex; align-items: center; justify-content: center; z-index: 500; padding: 24px;
  }
  .modal-content {
    background: #fff; width: 100%; max-width: 600px; border-radius: 32px; padding: 40px; box-shadow: 0 40px 100px rgba(15, 23, 42, 0.3);
  }

  .am-context-box {
    background: #f0f9ff; padding: 20px; border-radius: 20px; border: 1px solid #e0f2fe; margin-bottom: 24px; display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px;
  }
  .am-context-label { font-size: 11px; font-weight: 700; color: #64748b; text-transform: uppercase; }
  .am-context-val { font-size: 14px; font-weight: 800; color: #0c4a6e; }

  .am-textarea {
    width: 100%; padding: 18px; border-radius: 16px; border: 2px solid #f1f5f9; background: #f8fafc; font-size: 14px; font-family: inherit; font-weight: 600; resize: none; outline: none; transition: all 0.3s ease;
  }
  .am-textarea:focus { border-color: #0284c7; background: #fff; box-shadow: 0 0 0 4px rgba(2, 132, 199, 0.1); }

  @media (max-width: 768px) {
    .am-header { flex-direction: column; align-items: stretch; padding: 24px 20px; text-align: center; gap: 16px; }
    .dl-grid { grid-template-columns: 1fr; }
    .modal-content { padding: 24px; border-radius: 20px; }
    .am-context-box { grid-template-columns: 1fr; }
  }
`;

export default function Appointments() {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedAppt, setSelectedAppt] = useState(null);
  const [sending, setSending] = useState(false);
  const [reportForm, setReportForm] = useState({
    summary: "",
    topics: "",
    action_items: "",
  });

  const styleInjected = useRef(false);

  useEffect(() => {
    if (!styleInjected.current) {
      const tag = document.createElement("style");
      tag.textContent = APPT_MGMT_STYLES;
      document.head.appendChild(tag);
      styleInjected.current = true;
    }
    fetchAppointments();
  }, []);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", year: "numeric" }).format(date);
  };

  const formatTime = (timeStr) => {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const date = new Date();
    date.setHours(hours, minutes);
    return new Intl.DateTimeFormat("en-US", { hour: "numeric", minute: "numeric", hour12: true }).format(date);
  };

  const fetchAppointments = async () => {
    setLoading(true); setError("");
    try {
      const res = await axios.get(`${API}/api/appointments`);
      if (Array.isArray(res.data)) setAppointments(res.data);
      else { setAppointments([]); setError("Unexpected data format from API"); }
    } catch (err) {
      console.error("Error fetching appointments:", err);
      setError("Failed to fetch appointments.");
    } finally { setLoading(false); }
  };

  const openModal = (appt) => {
    setSelectedAppt(appt);
    setReportForm({ summary: "", topics: "", action_items: "" });
    setModalOpen(true);
  };
  const closeModal = () => { setModalOpen(false); setSelectedAppt(null); };

  const handleSendReport = async (e) => {
    e.preventDefault();
    if (!reportForm.summary.trim()) return toast.error("Please enter a meeting summary.");
    setSending(true);
    try {
      const payload = {
        appointment_id: selectedAppt.id, summary: reportForm.summary,
        topics: reportForm.topics ? reportForm.topics.split("\n").map(t => t.trim()).filter(Boolean) : [],
        action_items: reportForm.action_items ? reportForm.action_items.split("\n").map(a => a.trim()).filter(Boolean) : [],
      };
      const res = await axios.post(`${API}/api/fathom/send-report`, payload);
      toast.success(res.data.message || "Report sent successfully!");
      closeModal();
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to send report.");
    } finally { setSending(false); }
  };

  const handleTestWebhook = async (appointmentId) => {
    if (!window.confirm("Trigger a mock Fathom webhook for this appointment?")) return;
    try {
      toast.info("Triggering mock webhook...");
      const res = await axios.post(`${API}/api/fathom/test-webhook`, { appointment_id: appointmentId });
      toast.success(res.data.message || "Test webhook successful!");
      fetchAppointments();
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to test webhook.");
    }
  };

  return (
    <div className="am-root">
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Header */}
      <div className="am-header">
        <div>
          <p className="am-subtitle">Clinical Operations</p>
          <h1 className="am-title">Appointments Ledger</h1>
        </div>
        <div style={{ background: '#f8fafc', padding: '10px 24px', borderRadius: '14px', border: '1px solid #e2e8f0', fontWeight: 800, color: '#0c4a6e', fontSize: '13px' }}>
          Tracking System Active
        </div>
      </div>

      {/* Grid Layout taking over Table */}
      {loading ? (
        <div style={{ padding: '80px', textAlign: 'center', fontWeight: 800, color: '#0284c7', animation: 'pulse 2s infinite' }}>Syncing Global Ledger...</div>
      ) : error ? (
        <div style={{ padding: '40px', textAlign: 'center', color: '#b91c1c', fontWeight: 700 }}>{error}</div>
      ) : appointments.length === 0 ? (
        <div style={{ padding: '80px', textAlign: 'center', opacity: 0.5 }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>📅</div>
          <p style={{ fontWeight: 800, fontSize: '18px' }}>No Appointments Recorded</p>
        </div>
      ) : (
        <div className="dl-grid">
          {appointments.map((app) => (
            <div key={app.id} className="dl-card-outer">
              <div className="dl-card-ring" />
              <div className="dl-card-inner">
                <span className="am-ref-badge">#{app.id}</span>
                
                <div>
                  <div className="am-date">{formatDate(app.date)}</div>
                  <div className="am-time">⏰ {formatTime(app.time)}</div>
                </div>

                <div className="dl-divider" />
                
                <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
                  <span className="am-part-badge am-doc-badge">Doc {app.doctor_id}</span>
                  <span className="am-part-badge am-user-badge">User {app.user_id}</span>
                </div>

                <div style={{ marginBottom: '24px' }}>
                  {app.meeting_link ? (
                    <a href={app.meeting_link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#0284c7', fontWeight: 800, fontSize: '14px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                      🎥 Remote Session Linked
                    </a>
                  ) : (
                    <span style={{ fontSize: '14px', color: '#64748b', fontWeight: 600 }}>🏛️ Physical Visit</span>
                  )}
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: 'auto' }}>
                  {app.reason && (
                    <div style={{ fontSize: '13px', color: '#475569', background: '#f8fafc', padding: '8px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', fontStyle: 'italic' }}>
                      <span style={{ fontWeight: 700, color: '#0f172a', fontStyle: 'normal' }}>Reason: </span>
                      {app.reason}
                    </div>
                  )}
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button onClick={() => handleTestWebhook(app.id)} className="am-btn-action">
                      ⚡ Mock Sync
                    </button>
                    <button onClick={() => openModal(app)} className="am-btn-action am-btn-primary">
                      📝 Dispatch
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modern AI Dispatch Modal */}
      {modalOpen && selectedAppt && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' }}>
              <div>
                <h2 style={{ fontSize: '24px', fontWeight: 800, color: '#0c4a6e', margin: 0 }}>AI Manual Dispatch</h2>
                <p style={{ margin: '4px 0 0', fontSize: '11px', fontWeight: 700, color: '#0284c7', textTransform: 'uppercase' }}>Clinical Summary Portal</p>
              </div>
              <button onClick={closeModal} style={{ background: '#f1f5f9', border: 'none', width: '36px', height: '36px', borderRadius: '10px', cursor: 'pointer', fontWeight: 800, color: '#64748b' }}>✕</button>
            </div>

            <form onSubmit={handleSendReport}>
              <div className="am-context-box">
                <div>
                  <div className="am-context-label">Ref ID</div>
                  <div className="am-context-val">#{selectedAppt.id}</div>
                </div>
                <div>
                  <div className="am-context-label">Schedule</div>
                  <div className="am-context-val">{formatDate(selectedAppt.date)}</div>
                </div>
                <div>
                  <div className="am-context-label">Doctor</div>
                  <div className="am-context-val">{selectedAppt.doctor_id}</div>
                </div>
                <div>
                  <div className="am-context-label">Patient</div>
                  <div className="am-context-val">{selectedAppt.user_id}</div>
                </div>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: 700, color: '#475569', marginBottom: '8px' }}>Executive Summary *</label>
                <textarea
                  rows={4}
                  className="am-textarea"
                  placeholder="Summarize the core medical findings..."
                  value={reportForm.summary}
                  onChange={(e) => setReportForm((f) => ({ ...f, summary: e.target.value }))}
                  required
                />
              </div>

              <div style={{ display: 'flex', gap: '16px', justifyContent: 'flex-end', marginTop: '40px', borderTop: '1.5px solid #f1f5f9', paddingTop: '32px' }}>
                <button type="button" onClick={closeModal} style={{ background: '#f1f5f9', border: 'none', padding: '14px 24px', borderRadius: '12px', fontWeight: 800, color: '#64748b', cursor: 'pointer' }}>Discard</button>
                <button type="submit" disabled={sending} className="am-btn-action am-btn-primary" style={{ padding: '14px 32px' }}>
                  {sending ? "Transmitting..." : "Send AI Report"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}